import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import WithRender from '@/Pages/Admin/Modules/Hotel/tab/General/Location/Views/location.html';
import { common } from "@/Pages/Admin/Modules/Common/Services/Common";
import ValidationError from "@/Pages/Admin/Modules/Common/Controllers/ValidationError";
import {hotelService} from '@/Pages/Admin/Modules/Hotel/Services/HotelService'
import {flashService} from '@/Pages/Admin/Modules/Common/Services/FlashMessage/FlashService';
import { HotelModel } from "@/Pages/Admin/Modules/Models/Hotel/HotelModel";
import { CityModel } from "@/Pages/Admin/Modules/Models/Hotel/CityModel";

@WithRender
@Component({
    components: {
        
        'validation-error': ValidationError,
    },
})
export default class Location extends Vue {
    protected ui: any = {};
    protected item: any = {};
     protected postdata: any = {};
     
    constructor() {
        super();

        this.ui = {
            status: {
                isLoading: {
                      locationData: false,
                      listCity: false,

                },
                postLoading: {
                     addLocation: false,
                     saveCity: false,

                },
                canEdit: false,
                enableAddCity: false,
                showCity: false,
                checkTitle: false,
            },
            error: {
                errors: {},
                has_error: false,
               error_message: {},
                saveCity: {},
            },
        };

        this.item = {
             locationData: new HotelModel({}),
             tempLocationData: new HotelModel({}),
             cityList: new CityModel({}),
             addCity: new CityModel({}),
        };
    }

    public mounted() {
         this.getLocationsData();
         this.getCityList();

    }

    public getLocationsData() {
        this.ui.status.isLoading.locationData = true;
        let data = {
            hotel_id: this.$route.query.id,
        };
        hotelService.getLocation(data)
            .then((res: any) => {
                this.item.locationData = res.data.data;
            })
            .catch((error: any) => {
                this.ui.error.errors = error;
            })
            .finally(() => {
                this.ui.status.isLoading.locationData = false;
            });
    }

     public getCityList() {
        this.ui.status.isLoading.listCity = true;
        hotelService
            .getCityList()
            .then((res: any) => {
                this.item.cityList = res.data.data;
            })
            .catch((error: any) => {
                common.sdCatchErr(error, this.ui.error.error_message).then(res => {
                    this.ui.error.has_error = true;
                    this.ui.error.error_message = res;
                });
            })
            .finally(() => {
                this.ui.status.isLoading.listCity = false;
            });
    }
     
    protected createLocation() {
        this.resetError();
     //    if (!this.IsValidationTrue()) {
     //        return;
     //    }
        let data = {
            hotel_id: this.$route.query.id,
            city_id: this.item.locationData.city ? this.item.locationData.city.id : '',
        };
        this.ui.status.postLoading.addLocation = true;
        hotelService
            .updateLocation(data)
            .then((res: any) => {
                flashService.Success('city Added', res.data.message);
                this.ui.status.canEdit = false;
            })
            .catch((error: any) => {
                common.sdCatchErr(error, this.ui.error.error_message)
                    .then((res) => {
                        this.ui.error.error_message = res;
                    });
                flashService.Error('Error', 'Error while adding general notice.');
            })
            .finally(() => {
                this.ui.status.postLoading.addNotice = false;
            });
    }
     
    public onAddCityClick() {
        $('#addCity').modal('show');
        this.ui.status.enableAddCity = true;
    }


   public saveCity() {
        this.resetError();
        if (!this.validateSaveCityAction()) {
            return;
        }
        let data = {
            name: this.item.addCity.name,
        };
        this.ui.status.postLoading.saveCity = true;
        hotelService
            .addCity(data)
            .then((res: any) => {
                this.ui.status.enableAddCity = false;
                this.item.addCity = new CityModel({});
                flashService.Success('City Added', res.data.message);
                this.item.cityList.unshift(res.data.data);
                $('#addCity').modal('hide');
                $('.modal-backdrop').remove();
            })
            .catch((error: any) => {
                common.sdCatchErr(error, this.ui.error.error_message.saveCity).then(res => {
                    this.ui.error.error_message.saveCity = res;
                });
            })
            .finally(() => {
                this.ui.status.postLoading.saveCity = false;
            });
    }

    protected validateSaveCityAction() {
        if (!this.item.addCity.name) {
            Object.assign(this.ui.error.errors, {
                name: ['The name field is required.']
            });
        }
        if (common.notEmpty(this.ui.error.errors)) {
            this.ui.error.has_error = true;
            return false;
        } else {
            return true;
        }
    }

    public onCancelCityClick() {
        $('#addCity').modal('hide');
        $('.modal-backdrop').remove();
        this.resetError();
        this.ui.status.enableAddCity = false;
        this.ui.error.messages.saveCity = {};
        this.item.addCity = new CityModel({});
    }

    public get buttonName() {
        if (this.ui.status.postLoading.addLocation) {
            return 'Processing...';
        }
        return 'Save';
    }

    protected onEditLocationClick() {
        this.ui.status.canEdit = true;
        this.item.tempLocationData = Object.assign({}, this.item.locationData);
    }

    protected cancelLocation() {
        this.ui.status.canEdit = false;
        this.resetError();
        this.item.locationData = this.item.tempLocationData;
    }

    public resetError() {
        this.ui.error.errors = {};
        this.ui.error.has_error = false;
        this.ui.error.error_message = {};
    }

 protected IsValidationTrue() {
     if (!this.item.locationData.city) {
      Object.assign(this.ui.error.errors, {
          city: ["The city  is required."]
      });
    }

     if (common.notEmpty(this.ui.error.errors)) {
       this.ui.error.has_error = true;
            return false;
     } else {
      return true;
    }
 }
     
     

}
